import { ChangeDetectionStrategy, Component, inject, viewChild } from '@angular/core';

import { DropdownItemComponent } from '../../../../common/dropdown/dropdown-item/dropdown-item.component';
import { IconComponent } from '../../../../common/icon/icon.component';
import { Select2FooterDirective } from './footer.directive';

@Component({
  selector: 'rt-select-footer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Select2FooterDirective, DropdownItemComponent, IconComponent],
  template: `
    <ng-template rtSelectFooter>
      <ng-content />
    </ng-template>
  `,
  providers: [
    {
      provide: Select2FooterDirective,
      useFactory: () => inject(FooterDefaultComponent).directive(),
    },
  ],
})
export class FooterDefaultComponent {
  public directive = viewChild.required(Select2FooterDirective);
}
